import { pinia } from '@/store'
import { useSessionStore } from '@/store/session'

export const PERMISSIONS = {
  READ: 'tikuadapter.read.all',
  WRITE: 'tikuadapter.write.all',
  USE: 'tikuadapter.execute.all',
  MANAGE: 'tikuadapter.mgt.all',
  SEARCH_USE: 'tikuadapter.execute.all',
  QUESTION_READ: 'tikuadapter.read.all',
  QUESTION_WRITE: 'tikuadapter.write.all',
  NOTEBOOK_READ: 'tikuadapter.read.all',
  NOTEBOOK_WRITE: 'tikuadapter.write.all',
  USER_SETTINGS_READ: 'tikuadapter.read.all',
  USER_SETTINGS_WRITE: 'tikuadapter.write.all',
  QUOTA_READ: 'tikuadapter.execute.all',
  REQUEST_APPLY: 'tikuadapter.execute.all',
  REQUEST_LOG_READ: 'tikuadapter.read.all',
  USER_MANAGE: 'tikuadapter.mgt.all',
  REQUEST_REVIEW: 'tikuadapter.mgt.all',
  PROVIDER_MANAGE: 'tikuadapter.mgt.all',
  PRICING_MANAGE: 'tikuadapter.mgt.all',
  SEARCH_ORDER_MANAGE: 'tikuadapter.mgt.all',
  SYSTEM_CONFIG_READ: 'tikuadapter.mgt.all',
  SYSTEM_CONFIG_WRITE: 'tikuadapter.mgt.all',
  AUDIT_LOG_READ: 'tikuadapter.mgt.all',
  LOG_READ: 'tikuadapter.mgt.all',
  REQUEST_LOG_STATS_READ: 'tikuadapter.mgt.all',
}

export function getPermissionList() {
  return useSessionStore(pinia).permissions || []
}

export function hasPermission(permission) {
  const granted = getPermissionList().map(item => String(item || '').trim().toLowerCase())
  const required = String(permission || '').trim().toLowerCase()
  if (!required) return true
  if (granted.includes('*') || granted.includes('admin') || granted.includes(required)) return true
  for (const item of granted) {
    if (item === PERMISSIONS.MANAGE) {
      return true
    }
    if (item === PERMISSIONS.WRITE && (required === PERMISSIONS.READ || required === PERMISSIONS.USE)) {
      return true
    }
  }
  return false
}

export function hasAnyPermission(permissions = []) {
  return permissions.some(item => hasPermission(item))
}

export function hasGlobalAccess() {
  const granted = getPermissionList().map(item => String(item || '').trim().toLowerCase())
  return granted.includes('*') || granted.includes('admin') || granted.includes(PERMISSIONS.MANAGE)
}
